<template>
  <v-container fluid grid-list-lg class="login-container">
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-alert
          :value="true"
          v-if="error != null"
          type="error"
          v-html="error.message"
        ></v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="login">
            <v-text-field
              outline
              v-model="username"
              :rules="usernameRules"
              label="Email *"
              type="email"
              required
            ></v-text-field>

            <v-text-field
              outline
              v-model="pass"
              :rules="passRules"
              label="Password *"
              type="password"
              required
            ></v-text-field>

            <v-layout row align-center mx-1>
              <router-link to="/forgot-password" class="text-button"
                >Forgotten password?</router-link
              >
              <v-spacer />
              <button type="submit" :disabled="!valid" class="button">
                Login
              </button>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      valid: true,
      passRules: [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 8) ||
          "Remember, your password will have been at least 8 characters, contained a special character and contained both an upper case and a lower case letter",
      ],
      usernameRules: [
        (v) => !!v || "Email address is required",
        (v) => /.+@.+/.test(v) || "Email must be valid",
        (v) =>
          !v.includes(" ") || "An email address can not contain any spaces",
      ],
      username: "",
      pass: "",
      error: null,
      success: null,
      loading: false,
    };
  },
  mounted() {
    if (window.location.href.includes("code=true")) {
      //if the user is referred from a partner site
      localStorage.referrer = document.referrer;
      this.success = {
        message: "Your membership has been authenticated, please login below.",
      };
    }
  },
  methods: {
    login(e) {
      e.preventDefault();

      this.loading = true;
      var email = this.username;
      var password = this.pass;
      var vm = this
      this.$authenticateUser(email, password).subscribe(
        (data) => {
          // mobile app event trigger

          var lastSub = this.$cookie.get(
            `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`
          );
          var idToken = this.$cookie.get(
            `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`
          );
          var refreshToken = this.$cookie.get(
            `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.refreshToken`
          );
          var accessToken = this.$cookie.get(
            `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.accessToken`
          );

          var tokens = {
            idToken: idToken,
            refreshToken: refreshToken,
            accessToken: accessToken,
          };

          // Only attempt to post login success if they are coming from the app specific login route
          if (this.$router.currentRoute.name === "app-login") {
            if (typeof window.android !== "undefined") {
              window.android.onSignInSuccess(idToken);
              window.android.passTokens(JSON.stringify(tokens));
            }
            if (typeof window.webkit !== "undefined") {
              window.webkit.messageHandlers.iOS.postMessage(idToken);
              window.webkit.messageHandlers.iOSTokens.postMessage(
                JSON.stringify(tokens)
              );
            }
          }
          
          if (localStorage.returnUrl) {
            // if they were from a trusted referrer and we need to send them back with a JWT

            var authUser = this.$getAuthenticatedUser();
            authUser.getSession(function (err, session) {
              //
              var jwtToken = session.getIdToken().getJwtToken();

              if (localStorage.responseType == "post") {
                var form = document.createElement("form");
                document.body.appendChild(form);
                form.method = "post";
                form.action = localStorage.returnUrl;
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = "token";
                input.value = jwtToken;
                form.appendChild(input);

                localStorage.removeItem("returnUrl");
                localStorage.removeItem("suppressToken");
                localStorage.removeItem("responseType");
                form.submit();
              } else {
                var firstQueryChar = "?";
                if (localStorage.returnUrl.includes("?")) {
                  // account for ? in string
                  firstQueryChar = "&";
                }
                var redirect = localStorage.returnUrl;
                if (!localStorage.suppressToken) {
                  redirect = redirect + firstQueryChar + "token=" + jwtToken;
                }

                

                // Perform an address check upon redirect login (before it reaches /profile to avoid redirects)
                vm.$getCurrentUserAttributes().subscribe((userData) => {
                  if('custom:address_skip' in userData ){
                    // if they've previously skipped adding their address then (for now) we do nothing and just redirect them
                    // Clear local storage values before we redirect
                    localStorage.removeItem("returnUrl");
                    localStorage.removeItem("suppressToken");
                    localStorage.removeItem("responseType");
                    window.location = redirect
                  } else if (!userData.address.includes('street_address')) {
                    // If they haven't skipped and haven't set an address we ask them to do so
                    // Clear local storage values before we redirect
                    vm.$router.push("/complete-registration");
                  } else{
                    localStorage.removeItem("returnUrl");
                    localStorage.removeItem("suppressToken");
                    localStorage.removeItem("responseType");
                    window.location = redirect
                  }

                   
                })
                
              }
            });
          } else if (localStorage.referrer) {
            // if they were a referral sign in then clear this and redirect them.
            var redirect = localStorage.referrer;

            localStorage.removeItem("referrer");
            window.location = redirect;
          } else {
            var passhash = new URL(document.URL).hash; //add hash check
            this.$router.push("/profile" + passhash);
          }
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito

          this.error = err;
          if (
            err.code === "UnknownError" ||
            err.code === "newPasswordRequired"
          ) {
            this.$router.push("/login-set-password");
          }
          if (err.message === "Incorrect username or password.") {
            err.message =
              'Incorrect username or password - If you believe your email is correct please <a href="/forgot-password" class="text-button--login-error">reset your password</a>';
          }
          this.emailVerificationMessage = true;
        }
      );
    },
  },
};
</script>

<style scoped>
.login-container {
  margin-bottom: 70px;
}
.existing-message {
  margin-top: 30px;
  border: 2px solid;
  border-color: rgb(167, 166, 166);
  padding: 10px;
}

.reset-button {
  margin: 0 0 16px;
}

.error {
  display: block;
}
</style>